/* FreezBone bundle builder — quantity steppers, live totals with tiered
   savings estimate, AJAX add-to-cart. Scoped to <fbw-bundle-builder>.
   NOTE: the savings shown here are a display estimate; the real discount
   must exist as a Shopify automatic discount with the same tiers. */

(function () {
  'use strict';

  function formatMoney(cents) {
    // Uses Shopify's currency when available, falls back to USD formatting.
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  class FbwBundleBuilder extends HTMLElement {
    connectedCallback() {
      this.tiers = [1, 2, 3].map(function (n) {
        return {
          qty: parseInt(this.dataset['tier' + n + 'Qty'], 10) || 0,
          pct: parseInt(this.dataset['tier' + n + 'Pct'], 10) || 0,
          el: this.querySelector('[data-fbw-tier="' + n + '"]')
        };
      }, this).filter(function (t) { return t.qty > 0; });

      this.steppers = Array.prototype.slice.call(this.querySelectorAll('.fbw-stepper[data-variant-id]'));
      this.addBtn = this.querySelector('[data-fbw-add]');

      this.steppers.forEach(function (stepper) {
        stepper.querySelector('[data-fbw-plus]').addEventListener('click', this.step.bind(this, stepper, 1));
        stepper.querySelector('[data-fbw-minus]').addEventListener('click', this.step.bind(this, stepper, -1));
      }, this);

      if (this.addBtn) this.addBtn.addEventListener('click', this.addToCart.bind(this));
      this.update();
    }

    step(stepper, delta) {
      var out = stepper.querySelector('[data-fbw-qty]');
      var qty = Math.max(0, Math.min(99, (parseInt(out.value || out.textContent, 10) || 0) + delta));
      out.value = out.textContent = qty;
      this.update();
    }

    getItems() {
      return this.steppers
        .map(function (stepper) {
          var out = stepper.querySelector('[data-fbw-qty]');
          return {
            id: parseInt(stepper.dataset.variantId, 10),
            price: parseInt(stepper.dataset.price, 10),
            quantity: parseInt(out.value || out.textContent, 10) || 0
          };
        })
        .filter(function (item) { return item.quantity > 0; });
    }

    update() {
      var items = this.getItems();
      var count = items.reduce(function (sum, i) { return sum + i.quantity; }, 0);
      var subtotal = items.reduce(function (sum, i) { return sum + i.price * i.quantity; }, 0);

      var pct = 0;
      this.tiers.forEach(function (tier) {
        var active = count >= tier.qty;
        if (tier.el) tier.el.classList.toggle('is-active', active);
        if (active && tier.pct > pct) pct = tier.pct;
      });

      var savings = Math.round(subtotal * pct / 100);

      var set = function (sel, text) {
        var el = this.querySelector(sel);
        if (el) el.textContent = text;
      }.bind(this);

      set('[data-fbw-count]', count);
      set('[data-fbw-subtotal]', formatMoney(subtotal));
      set('[data-fbw-savings]', '−' + formatMoney(savings));
      set('[data-fbw-total]', formatMoney(subtotal - savings));

      if (this.addBtn) this.addBtn.disabled = count === 0;
    }

    addToCart() {
      var items = this.getItems().map(function (i) { return { id: i.id, quantity: i.quantity }; });
      if (!items.length) return;

      var btn = this.addBtn;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        })
        .catch(function (err) {
          btn.textContent = original;
          btn.disabled = false;
          alert(err.message);
        });
    }
  }

  if (!customElements.get('fbw-bundle-builder')) {
    customElements.define('fbw-bundle-builder', FbwBundleBuilder);
  }
})();
